import { render, staticRenderFns } from "./WidddiNav.vue?vue&type=template&id=41616e28"
import script from "./WidddiNav.vue?vue&type=script&lang=js"
export * from "./WidddiNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports